import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ChartView } from 'src/Libs/chart-kit/shared/utils/chartModel'
import { addMinutes, DEFAULT_HUMAN_TIME, format } from '@e3dc-react/shell/Libs/date'

/**
 * Builds text value for electricity chart tooltip based on selected view
 *
 * @param dateTime
 * @param view
 * @returns
 */
export const useBuildTimeValueText = (dateTime: string | undefined, view: ChartView): string => {
  const { t } = useCustomTranslation()

  if (!dateTime) {
    return ''
  }

  const date = new Date(dateTime)

  if (view === 'day' || view === 'hour') {
    const timeAmountToAdd = 15

    const timeValueRangeStart = format(date, DEFAULT_HUMAN_TIME)
    const timeValueRangeEnd = format(addMinutes(date, timeAmountToAdd), DEFAULT_HUMAN_TIME)
    const timeRange = `${timeValueRangeStart} - ${timeValueRangeEnd}`

    return t('dynamic-power-prices.cost-saving-chart.tooltip.time', { value: timeRange })
  }

  return format(date, t('common.format.date-fns-date'))
}
